module.exports = __webpack_public_path__ + "h5/img/Ying.7be6c0c3.jpg";